import React, { createContext, useContext, useReducer, useEffect } from 'react';
// Actions
import { list as ctaLogList } from '../actions/ctalogs';
// Utils
import { sortList } from '../utils/Sort';

const CTALogsContext = createContext();

const initialState = {
  data: [],
  sort: {
    type: null,
    accessor: null,
  },
  loading: true,
  reload: false,
  filters: {
    type: null,
    class: null,
    status: null,
  },
};

const dataReducer = (state, action) => {
  switch (action.type) {
    case 'SET_DATA':
      return { ...state, data: action.payload, loading: false };
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
    case 'SET_SORT':
      return { ...state, sort: action.payload };
    case 'SET_RELOAD':
      return { ...state, reload: action.payload };
    case 'SET_FILTERS':
      return { ...state, filters: action.payload };
    default:
      return state;
  }
};

export const CTALogsDataProvider = ({ children }) => {
  // useReducer
  const [state, dispatch] = useReducer(dataReducer, initialState);

  // useEffect
  useEffect(() => {
    dispatch({ type: 'SET_LOADING', payload: true });

    const fetchData = async () => {
      await ctaLogList({
        typeId: state.filters.type,
        classId: state.filters.class,
        statusId: state.filters.status,
        success: (data) => {
          handleSorting(data);
        },
        error: (error) => {
          throw new Error('Failed to fetch data');
        },
      });
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.filters.type, state.filters.class, state.filters.status, state.reload]);

  useEffect(() => {
    handleSorting(state.data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.sort]);

  // Methods
  const handleSorting = (data) => {
    if (state.sort.accessor && state.sort.type) {
      const sortedList = sortList(data, state.sort.accessor, state.sort.type);

      dispatch({ type: 'SET_DATA', payload: sortedList.data });
    } else {
      dispatch({ type: 'SET_DATA', payload: data });
    }
  };

  return <CTALogsContext.Provider value={{ state, dispatch }}>{children}</CTALogsContext.Provider>;
};

export const useCTALogsData = () => {
  const context = useContext(CTALogsContext);
  if (!context) {
    throw new Error('useCTALogsData must be used within a CTALogsDataProvider');
  }
  return context;
};
